const resourcePickerReducers = {
  openProductPicker: false,
  openCollectionPicker: false,
  openArticlePicker: false
};

function reducerActions(state, action) {
  if (typeof action.onSelected === 'function') {
    state.onSelected = action.onSelected;
  }
  switch (action.type) {
    case 'setOpenProductPicker':
      if (state.actionResourceDataPickerProduct) state.actionResourceDataPickerProduct(v => v + 1);
      state.openProductPicker = action.payload;
      return state;
    case 'setOpenCollectionPicker':
      if (state.actionResourceDataPickerCollection) state.actionResourceDataPickerCollection(v => v + 1);
      state.openCollectionPicker = action.payload;
      return state;
    case 'setOpenArticlePicker':
      if (state.actionResourceDataPickerArticle) state.actionResourceDataPickerArticle(v => v + 1);
      state.openArticlePicker = action.payload;
      return state;
    case 'onSelected':
      if (state.onSelected) state.onSelected(action.payload);
      return state;
    // case 'setActionOnSelected':
    //   state.onSelected = action.onSelected;
    //   return state;
    case 'setActionResourceDataPickerProduct':
      state.actionResourceDataPickerProduct = action.payload;
      return state;
    case 'setActionResourceDataPickerCollection':
      state.actionResourceDataPickerCollection = action.payload;
      return state;
    case 'setActionResourceDataPickerArticle':
      state.actionResourceDataPickerArticle = action.payload;
      return state;
    default:
      return state;
  }
  // throw Error("Unknown action.");
}

export { reducerActions, resourcePickerReducers };
